export default {
  API_ENDPOINT: 'https://lit-crag-58856.herokuapp.com/api',
  /*
  API_ENDPOINT: 'http://localhost:8000/api',
  */
  TOKEN_KEY: 'blogful-client-auth-token',
};
